module.exports = __webpack_public_path__ + "static/media/story_03.f4803f58.jpg";